import type { ItemPacking, VehicleTypes } from '@hero/schema';
import { vehicles } from '../config/vehicle.config';

export type LoadPackingAndQuantity = {
  packing: ItemPacking;
  quantity: number;
};

const FALLBACK: LoadPackingAndQuantity = { packing: 'pallet', quantity: 24 };

/**
 * Derive default load packing + quantity from one or more accepted
 * vehicle types. When multiple types are selected, picks the spec
 * with the **largest** catalog `quantity` (e.g. truck 24 pallets beats
 * lorry 8) and uses that vehicle's `packing`.
 *
 * Used by client order-settings, publish-order auto-apply, and any
 * surface that seeds load detail from preferred vehicles.
 */
export function resolveLoadPackingAndQuantityFromVehicles(
  vehicleTypes: VehicleTypes[],
): LoadPackingAndQuantity {
  if (!vehicleTypes.length) return FALLBACK;

  let winner = vehicles.types.find(spec => spec.id === vehicleTypes[0]);
  for (const vt of vehicleTypes.slice(1)) {
    const spec = vehicles.types.find(s => s.id === vt);
    if (!spec) continue;
    if (!winner || spec.quantity > winner.quantity) {
      winner = spec;
    }
  }

  if (!winner) return FALLBACK;
  return { packing: winner.packing, quantity: winner.quantity };
}
